import { render, staticRenderFns } from "./SkeletonDashboard.vue?vue&type=template&id=f3108800&"
import script from "./SkeletonDashboard.vue?vue&type=script&lang=js&"
export * from "./SkeletonDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports